/**
 * Copyright (c) 2021 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import * as R from 'ramda';

import Loading from '../../loading/loading.component';

import {
  DOCUMENT_CHANGE_STATUS_SOP_OPTIN_OPTOUT_STEP_DESCRIPTION,
  DOCUMENT_CHANGE_STATUS_SOP_OPTIN_OPTOUT_LABEL,
  DOCUMENT_CHANGE_STATUS_SOP_OPTIN_OPTOUT_NO_VALUES,
  PREVIOUS_BTN,
  CANCEL_BTN,
  SAVE_BTN,
  NEXT_BTN
} from '../../../const.js';

import { Checkbox, Form, FormControl, FormGroup, Grid, ListGroupItem, Radio, Row } from 'react-bootstrap';
import { generateIteratorKey as keygen } from '../../../utils/helpers';
import Notification from '../../common/notification/notification.component';
import { Button } from 'tc-client-common';
import PropTypes from 'prop-types';

class DocumentChangeStatusFillSoPOptInOptOutComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selection: props.props.selection
    };
  }

  componentDidMount() {
    if (this.props.listOfOptInOptOut.length === 0) {
      const { consentGid, consentingGid } = this.props.props;
      this.props.loadDocumentOptInsOutsWithState(consentGid, consentingGid);
    }
  }

  componentDidUpdate() {
    if (!this.state.selection && this.props.consentingOptInState) {
      this.setState((state, props) => ({ selection: props.consentingOptInState }));
    }
  }

  saveDocumentStatusWithOptInOptOuts = (e) => {
    e.preventDefault();

    const { selection = [] } = this.state;

    const choiceAnswers = this.getChoiceAnswersChanges();
    this.props.next({ ...this.props.props, selection, choiceAnswers });
  };

  getChoiceAnswersChanges = () => {
    const { listOfOptInOptOut } = this.props;
    const consentingOptInState = this.props.consentingOptInState || [];

    const { selection = [] } = this.state;

    const yesChoices = selection.filter((optionId) => !consentingOptInState.includes(optionId));
    const noChoices = consentingOptInState.filter((optionId) => !selection.includes(optionId));
    const submitChoices = yesChoices.concat(noChoices);

    return listOfOptInOptOut
      .flatMap((item) => item.options)
      .filter((option) => submitChoices.includes(option.id))
      .map(({ id, sponsor }) => ({
        sponsor,
        questionId: id,
        choiceAnswerType: yesChoices.includes(id) ? 'YES' : 'NO'
      }));
  };

  hideOnCancel = () => {
    this.props.cancel();
  };

  optInOptOutChange = (e) => {
    const { checked, value } = e.target;
    const valueToInt = +value;

    this.setState(({ selection }) => {
      const newSelection = [].concat(selection);
      if (checked) {
        newSelection.push(valueToInt);
      } else {
        newSelection.splice(newSelection.indexOf(valueToInt), 1);
      }
      return { selection: newSelection };
    });
  };

  radioOptInOptOutChange =
    (allRadioGroupOptionIds = []) =>
    (e) => {
      const { value } = e.target;
      const valueToInt = +value;

      this.setState(({ selection = [] }) => {
        const newSelection = selection.filter((item) => !allRadioGroupOptionIds.includes(item));
        newSelection.push(valueToInt);
        return { selection: newSelection };
      });
    };

  render() {
    if (this.props.consentingOptInState == null) {
      return <Loading />;
    } else if (this.props.isLoading) {
      return <Loading />;
    } else {
      const errorBody = this.props.error && (
        <Row {...keygen()}>
          <Notification type="error" data={this.props.error} />
        </Row>
      );
      const stateSelection = this.state.selection || [];
      const optInOptOutsWithSelectedValues = this.props.listOfOptInOptOut.map(({ type, options }) => ({
        type,
        options: options.map((item) => ({ ...item, checked: stateSelection.includes(item.id) }))
      }));

      const handlePreviousStep = (e) => {
        e.preventDefault();
        this.props.previous({ ...this.props.props, selection: stateSelection });
      };

      const isSubmitButtonDisabled = () => {
        return this.props.isChangeRequired && R.equals(stateSelection, this.props.consentingOptInState);
      };

      return (
        <div>
          <Form horizontal id="edit-document-optinoptouts-form" onSubmit={this.saveDocumentStatusWithOptInOptOuts}>
            <Grid id="edit-document-status-optinoptout-grid" fluid>
              {errorBody}
              <Row {...keygen()}>
                <FormGroup>
                  <FormControl.Static>{DOCUMENT_CHANGE_STATUS_SOP_OPTIN_OPTOUT_STEP_DESCRIPTION}</FormControl.Static>
                </FormGroup>
              </Row>
              <Row key={22}>
                <FormGroup>
                  <h4>{DOCUMENT_CHANGE_STATUS_SOP_OPTIN_OPTOUT_LABEL}</h4>
                  <div className="participant-selections-list participant-selections-list-border">
                    {optInOptOutsWithSelectedValues.length === 0 ? (
                      <ListGroupItem {...keygen()}>{DOCUMENT_CHANGE_STATUS_SOP_OPTIN_OPTOUT_NO_VALUES}</ListGroupItem>
                    ) : (
                      optInOptOutsWithSelectedValues.map(({ type, options }, index) => (
                        <ListGroupItem key={`${type}-${index}`}>
                          {options.map(({ id, text, checked = false }) => {
                            if (type === 'input-checkbox') {
                              return (
                                <Checkbox key={id} value={id} checked={checked} onChange={this.optInOptOutChange}>
                                  {text}
                                </Checkbox>
                              );
                            } else {
                              return (
                                <Radio
                                  key={id}
                                  name={`radioGroup-${index}`}
                                  value={id}
                                  checked={checked}
                                  onChange={this.radioOptInOptOutChange(options.map(({ id }) => id))}
                                >
                                  {text}
                                </Radio>
                              );
                            }
                          })}
                        </ListGroupItem>
                      ))
                    )}
                  </div>
                </FormGroup>
              </Row>
            </Grid>
            <br />
            <div className="edit-modal-footer">
              <hr className="edit-modal-divider" />
              <Button theme="default large-button" handleClick={handlePreviousStep} label={PREVIOUS_BTN} />
              <Button
                id="edit-document-status-optinoptout-cancel-button"
                type="reset"
                theme="default large-button"
                handleClick={this.hideOnCancel}
                label={CANCEL_BTN}
              />
              <Button
                id="edit-document-status-save-button"
                theme="active large-button"
                disabled={isSubmitButtonDisabled()}
                label={this.props.hasNext ? NEXT_BTN : SAVE_BTN}
                type="submit"
              />
            </div>
          </Form>
        </div>
      );
    }
  }
}

DocumentChangeStatusFillSoPOptInOptOutComponent.defaultProps = {
  listOfOptInOptOut: []
};

DocumentChangeStatusFillSoPOptInOptOutComponent.propTypes = {
  isLoading: PropTypes.bool,
  error: PropTypes.object,
  listOfOptInOptOut: PropTypes.arrayOf(PropTypes.object),

  props: PropTypes.shape({
    consentGid: PropTypes.string.isRequired,
    consentingGid: PropTypes.string.isRequired,
    studyGid: PropTypes.string.isRequired,
    participantId: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
    statusDate: PropTypes.string.isRequired,
    reason: PropTypes.string.isRequired,
    selection: PropTypes.arrayOf(PropTypes.number)
  }).isRequired,

  loadDocumentOptInsOutsWithState: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  previous: PropTypes.func.isRequired
};

export default DocumentChangeStatusFillSoPOptInOptOutComponent;
